import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from "../../../store/storeFunctions";
import { popupActions } from '../../../store/popupStore';
import { withLocalize, Translate } from "react-localize-redux";
import classnames from 'classnames';
import moment from 'moment';

class AmlCandidate extends React.Component {
    state = { extend: false }

    render() {
        const hasBirthDateOnInputOnly = this.hasBirthDateOnInputOnly(this.props.candidate.dateOfBirthsFormatted);
        let birthDatesFormatted = "";
        if (!isNullOrUndefined(this.props.candidate.birthDates)) {
            birthDatesFormatted = this.props.candidate.birthDates.map((x) => moment(x).format('DD. MM. YYYY'));
        }

        if (this.props.candidate.isCountryMatch && !this.props.candidate.sources.includes(this.props.candidate.primaryName))
            this.props.candidate.sources.push(this.props.candidate.primaryName);

        return (<>
            <tr className="colorize">
                <td style={{ fontWeight: "bold" }}>{this.props.candidate.isCountryMatch ? this.props.candidate.country : this.props.candidate.primaryName}</td>
                {<td className={classnames({ 'aml-candidate-red': hasBirthDateOnInputOnly })} style={{ textAlign: "right" }}>{this.props.candidate.confidenceRate}</td>}
                {<td className={classnames({ 'aml-candidate-red': hasBirthDateOnInputOnly })}>{hasBirthDateOnInputOnly  ?  !this.props.candidate.isCountryMatch ? this.props.translate("Report.Aml.Subjects.Unlisted") : "" : this.props.candidate.dateOfBirthsFormatted.join(",")}</td>}
              
                {<td>{this.props.candidate.placesOfBirth.join(",")}</td>}
                {<td>{this.props.candidate.sources.join(", ")}</td>}               
                <td style={{ textAlign: "right" }} onClick={() => this.extend()}>
                    <span className="link-functional">{this.props.translate("Report.Detail")}</span>
                </td>
            </tr>
            {this.state.extend && this.renderCandidateDetail()}
        </>
        );
    }

    renderCandidateDetail() {
        return (
            <tr >
                <td className="nested-table aml-candidate" colSpan={6}>
                    <table style={{ width: "100%" }} className="table table-report-section key-value aml-candidate">
                        <tbody>
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.FurtherNames" />, this.props.candidate.furtherNames)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.KnownAddresses" />, this.props.candidate.knownAddresses)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.PassportOrIds" />, this.props.candidate.passportsOrIds)}
                            {this.renderSingleValueRow(<Translate id="Report.Aml.Subjects.Age" />, this.props.candidate.age)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.FurtherCountries" />, this.props.candidate.furtherCountries)}
                            {this.renderSingleValueRow(<Translate id="Report.Aml.Subjects.Domicil" />, this.props.candidate.country)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.Keywords" />, this.props.candidate.keywords)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.AdditionalInfo" />, this.props.candidate.additionalInfo)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.Titles" />, this.props.candidate.titles)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.DateOfLastUpdate" />, this.props.candidate.datesOfLastUpdateFormatted)}
                            {this.renderArrayValueRow(<Translate id="Report.Aml.Subjects.Publisher" />, this.props.candidate.publishers)}
                        </tbody>
                    </table>
                </td>
            </tr>
        );
    }

    hasBirthDateOnInputOnly = (dateOfBirths) => this.props.hasBirthDate && (isNullOrUndefined(dateOfBirths) || dateOfBirths.length === 0);

    extend() {
        this.setState({ extend: !this.state.extend })
    }

    renderSingleValueRow = (title, value) => value && (
        <tr>
            <td className="bold" style={{ width: "30%" }}>{title}</td>
            <td>{value}</td>
        </tr>
    );

    renderArrayValueRow = (title, array) => array && array.length > 0 && (
        <tr>
            <td className="bold" style={{ width: "30%" }}>{title}</td>
            <td>{array.join(", ")}</td>
        </tr>
    )
}

export default withLocalize(connect(
    state => state,
    dispatch => bindActionCreators(popupActions, dispatch)
)(AmlCandidate));